// extracted by mini-css-extract-plugin
var _1 = "PageContainer_container__WmMRE";
var _2 = "992px";
var _3 = "768px";
var _4 = "\"../../shared.module.css\"";
var _5 = "1200px";
export { _1 as "container", _2 as "lg", _3 as "md", _4 as "shared", _5 as "xl" }
